var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import { inject } from 'mobx-react';
import ToggleSelect from '../../../elements/ToggleSelect';
import { T } from '../../../helpers/i18n';
import { ButtonsBar, StyledButton } from '../../../Styles';
import { loading } from '../../../elements/Loading';
import cxs from 'cxs/component';
import PropTypes from 'prop-types';
import { ModalDestinationForm } from './ModalDestinationForm';
var DestinationTable = /** @class */ (function (_super) {
    __extends(DestinationTable, _super);
    function DestinationTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hideFormLanguages: true,
            destination: null,
            hideDefault: true,
            selectAllDefault: false,
            hideFormDestination: true
        };
        _this.handleChange = function (_a) {
            var field = _a.field, value = _a.value, language = _a.language;
            var temp = _this.state.destination || {};
            if (field === 'name') {
                temp[field] = value;
            }
            else {
                if (!temp.hasOwnProperty('value') || !temp.value) {
                    temp['value'] = {};
                }
                temp.value[language] = value;
            }
            _this.setState({ destination: temp });
        };
        _this.handleSave = function () {
            if (_this.state.destination.id) { // actualizo
                _this.props.store.destinationsStore.update(_this.state.destination.id, _this.state.destination)
                    .then(function (value) {
                    _this.props.store.UI.newWarning(T('saved'));
                    _this.setState({ destination: null, hideFormLanguages: true });
                    _this.props.reload();
                })
                    .catch(function (error) {
                    _this.props.store.UI.newError('error');
                });
                return;
            }
            // creo uno nuevo
            _this.props.store.destinationsStore.create(_this.state.destination).then(function (value) {
                _this.setState({ destination: null, hideFormLanguages: true });
                _this.props.reload();
                _this.props.store.UI.newWarning(T('saved'));
            });
        };
        _this.handleCancel = function () {
            _this.setState({ hideFormLanguages: true, destination: null });
        };
        _this.handleItemClick = function (item) {
            var items = _this.props.destinations;
            var itemSelected = items.find(function (itemClicked) { return item.id === itemClicked.id; });
            _this.setState({ destination: __assign({}, itemSelected), hideFormLanguages: false });
        };
        _this.handleDelete = function (item) {
            var result = confirm('¿Está seguro de eliminar esta ciudad?');
            console.log(result);
            if (result) {
                _this.props.store.destinationsStore.deleteCity(item)
                    .then(function (response) {
                    console.log('response: ', response);
                    if (response && response.result === 'ok') {
                        _this.props.reload();
                    }
                });
            }
        };
        _this.handleDefault = function () {
            _this.setState({ hideDefault: false });
        };
        _this.handleAddMultiple = function () {
            var value = [];
            _this.props.store.destinationsStore.addMultiple(value);
        };
        _this.handleClickAdd = function (_a) {
            var selected = _a.selected;
            return __awaiter(_this, void 0, Promise, function () {
                var value, promise, error_1, promise;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.props.store.destinationsStore.addMultiple(selected)];
                        case 1:
                            value = _b.sent();
                            promise = new Promise(function (resolve, reject) {
                                resolve(true);
                                _this.props.reload();
                            });
                            return [2 /*return*/, promise];
                        case 2:
                            error_1 = _b.sent();
                            console.log('catch - error: ', error_1);
                            promise = new Promise(function (resolve, reject) {
                                reject(false);
                            });
                            return [2 /*return*/, promise];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        _this.handleClickCancel = function () {
            console.log('onClickCancel');
            _this.setState({ hideFormDestination: true });
        };
        return _this;
    }
    DestinationTable.prototype.render = function () {
        var _this = this;
        var _a;
        var options = ((_a = this.props.destinations) === null || _a === void 0 ? void 0 : _a.map(function (item, index) {
            return {
                id: item.id,
                name: item.name,
                value: item.id
            };
        })) || [];
        var _b = this.state, hideFormLanguages = _b.hideFormLanguages, destination = _b.destination, hideFormDestination = _b.hideFormDestination;
        var title = destination === null || destination === void 0 ? void 0 : destination.name;
        return (React.createElement("div", null,
            React.createElement(ToggleSelect, { itemChild: function (item, toggleSelectClickHandler) {
                    var _a, _b;
                    return (React.createElement(ItemWrapper, { key: "tsdiv_".concat(item.name), selected: ((_a = _this.state.destination) === null || _a === void 0 ? void 0 : _a.id) === item.id },
                        React.createElement("div", { key: "tsi_".concat(item.name) }, item.name),
                        React.createElement("button", { style: { marginLeft: '10px' } },
                            React.createElement("i", { className: "fa ".concat(((_b = _this.state.destination) === null || _b === void 0 ? void 0 : _b.id) === item.id ? '' : 'fa-trash'), onClick: function (e) {
                                    e.stopPropagation();
                                    _this.handleDelete(item);
                                } }))));
                }, options: options, onChange: function (e) {
                    console.log('onChange', e);
                    // no es multiple
                    /*
                     this.handleItemClick(item)
                    */
                } }),
            React.createElement(ButtonsBar, null,
                React.createElement(StyledButton, { primary: true, onClick: function () {
                        _this.setState({ hideFormDestination: false });
                    } }, T('add'))),
            React.createElement(ModalDestinationForm, { countries: this.props.countries, hide: hideFormDestination, onClickSave: function (data) {
                    console.log('onClickSave: ', data);
                    _this.props.store.destinationsStore.addCities(data)
                        .then(function (response) {
                        _this.props.reload();
                    });
                }, onClickCancel: this.handleClickCancel })));
    };
    DestinationTable = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.store.destinationsStore.read().then(function (destinations) { return ({ destinations: destinations }); }),
            props.store.destinationsStore.readCountries(null, { withCities: true, withStates: true }).then(function (countries) { return ({ countries: countries }); }),
        ]; })
    ], DestinationTable);
    return DestinationTable;
}(Component));
export default DestinationTable;
export var ItemWrapper = cxs('div')(function (_a) {
    var selected = _a.selected;
    return (__assign(__assign({ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '10px', margin: '5px', border: '1px solid lightgray' }, selected ? { borderColor: 'green', color: 'white', backgroundColor: 'green' } : undefined), { borderRadius: '10px' }));
});
ItemWrapper.propTypes = {
    selected: PropTypes.bool,
};
// Arenal, concorvado, La Fortuna, Manuel Antonio, Tamarindo, San José



//////////////////
// WEBPACK FOOTER
// ./src/modules/Destinations/containers/DestinationTable.tsx
// module id = 1618
// module chunks = 0